import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";
import { setRealtimeEvent } from "../../realtime/realtimeSlice";
import {
    getRealtimeEntityFromPayload,
    isModuleMatch,
} from "../../realtime/realtimeUtils";

const BackendURL = config.backendUrl;

// 📌 Async Thunk — assign user(s) to project
export const assignUserToProject = createAsyncThunk(
    "managerProject/assignUserToProject",
    async ({ projectid, userids, duedate }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `${BackendURL}/managerProjectRequested/assignUser`,
                { projectid, userids, duedate }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to assign users"
            );
        }
    }
);

const managerProjectAssignSlice = createSlice({
    name: "managerProjectAssign",
    initialState: {
        loading: false,
        error: null,
        success: false,
        assignedProject: null,
    },
    reducers: {
        resetAssignState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.assignedProject = null;
        },
    },
    extraReducers: (builder) => {
        builder

            // 📌 Pending
            .addCase(assignUserToProject.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })

            // 📌 Fulfilled
            .addCase(assignUserToProject.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.assignedProject = action.payload.project;
                state.error = null;
            })

            // 📌 Rejected
            .addCase(assignUserToProject.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            })
            .addCase(setRealtimeEvent, (state, action) => {
                const { module, action: eventAction, data } = action.payload || {};
                if (!isModuleMatch(module, ["users", "user", "employees"])) return;
                if (eventAction !== "updated") return;

                const incomingItem = getRealtimeEntityFromPayload(data);
                if (!incomingItem || !state.assignedProject) return;

                // Merge shallow user-related changes when they reference this project.
                const incomingProjectId =
                  incomingItem.projectid || incomingItem.projectId || incomingItem._id;
                const currentProjectId =
                  state.assignedProject.projectid ||
                  state.assignedProject.projectId ||
                  state.assignedProject._id;

                if (incomingProjectId && currentProjectId && incomingProjectId !== currentProjectId) {
                  return;
                }

                state.assignedProject = {
                  ...state.assignedProject,
                  ...incomingItem,
                };
            });
    },
});

export const { resetAssignState } = managerProjectAssignSlice.actions;

export default managerProjectAssignSlice.reducer;
